import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ListBirthdaysComponent } from './list-birthdays/list-birthdays.component';
import { EditBirthdayComponent } from './edit-birthday/edit-birthday.component';
import { BirthdaysComponent } from './birthdays.component';
import { birthdayRoutes } from './birthdays.routes';
import { RouterModule } from '@angular/router';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import {MatDatepickerModule, MatButtonModule, MatIconModule, MatNativeDateModule, MAT_DATE_LOCALE} from '@angular/material';
import { ApiService } from '../api.service';
import { CalendarBirthdayComponent } from './calendar-birthday/calendar-birthday.component';
import {MenuService} from '../menu/menu.service';
import {SharedModule} from '../shared/shared.module';
import { TagsModule } from '../tags/tags.module';
import {DashboardService} from '../dashboard.service';
import {BirthdaysService} from './birthdays.service';
import {SearchService} from '../search/search.service';
import {SearchResult, SearchResultItem} from '../search/interface.search';

interface Birthday {
    _id?: string;
    firstname: string;
    lastname: string;
    birthday: string;
    age?: number;
    daysUntil?: number;
    tags: Array<string>;
}

const routing: ModuleWithProviders = RouterModule.forRoot(birthdayRoutes);
@NgModule({
  imports: [
    CommonModule,
      FormsModule,
      ReactiveFormsModule,
      MatDatepickerModule,
      MatNativeDateModule,
      MatIconModule,
      MatButtonModule,
      SharedModule,
      TagsModule,
      routing
  ],
  declarations: [
      ListBirthdaysComponent,
      EditBirthdayComponent,
      BirthdaysComponent,
      CalendarBirthdayComponent,
  ],
    providers: [
        // `MomentDateAdapter` can be automatically provided by importing `MomentDateModule` in your
        // application's root module. We provide it at the component level here, due to limitations of
        // our example generation script.
        {provide: MAT_DATE_LOCALE, useValue: 'de-DE'},
        DashboardService,
        BirthdaysService
    ],
})
export class BirthdaysModule {
    constructor(
        protected menuService: MenuService,
        protected dashboardService: DashboardService,
        protected searchService: SearchService,
        protected apiService: ApiService,
        protected birthdaysService: BirthdaysService) {
        this.menuService.addMenuItems(
            [
                {
                    name: 'birthdays',
                    path: '/birthdays',
                    icon: 'far fa-calendar-alt',
                    children: [
                        {
                            name: 'list',
                            path: '/birthdays/list'
                        },
                        {
                            name: 'calendar',
                            path: '/birthdays/calendar'
                        },
                        {
                            name: 'new',
                            path: '/birthdays/new'
                        }
                    ]
                }]);
        this.searchService.getSearchTermSubject().subscribe((val) => {
           this.searchService.addSearchResult('birthdays',
               {
                   title: 'Fetching search results for birthdays ...',
                   items: [],
                   footer: {text: '', buttons: []},
                   icon: 'far fa-calendar-alt'}
                   );
            this.apiService.search('birthdays', val).subscribe(
                (value: Array<Birthday>) => {
                    const searchResult: SearchResult = {
                            title: 'Birthdays',
                            items: [],
                        footer: {text: '', buttons: [{link: '/birthdays', linkText: 'All birthdays'}]},

                        icon: 'far fa-calendar-alt'
                        };
                    for (const item of value) {
                        const birthday = new Date(item.birthday);
                        const resultItem = {
                            label: item.firstname + ' ' + item.lastname + ', birthday is on: ' + birthday.toDateString(),
                            routerLink: ['/birthdays/edit/', item._id],
                            link: ''
                        };
                        searchResult.items.push(resultItem);
                    }
                    if (value.length === 0) {
                        searchResult.footer.text = 'No items found';
                    }
                    this.searchService.addSearchResult('birthdays', searchResult);
                });
        });
        this.dashboardService.fetchItems.subscribe((val) => {
           console.log('birthdays module listened to dashboard service event fetchItems');
            this.dashboardService.addDashboardItem('birthdays', {title: 'Birthdays', items: [], footer: '', icon: 'far fa-calendar-alt'});

            this.apiService.getAll('birthdays').subscribe(
                (value) => {
                    let birthdays: any = value;
                    console.log('birthday dashboard service got birthdays:', birthdays);
                    birthdays = birthdays.map((birthday) => {
                        birthday.birthday = new Date(birthday.birthday);
                        birthday.daysUntil = this.birthdaysService.daysUntil(birthday.birthday);
                        birthday.age = this.birthdaysService.today.getFullYear() - birthday.birthday.getFullYear();
                        if (birthday.birthday.getMonth() < this.birthdaysService.today.getMonth() ||
                            (
                                birthday.birthday.getMonth() === this.birthdaysService.today.getMonth()
                                && birthday.birthday.getDate() < this.birthdaysService.today.getDate()
                            )
                        ) {
                            birthday.age++;
                        }
                        return birthday;
                    });
                    console.log('after mapping: ', birthdays);
                    birthdays.sort((a, b) => {
                        return b['daysUntil'] < a['daysUntil'] ? 1 : -1;
                    });
                    const limitTo = Math.min(10, birthdays.length);
                    birthdays.length = limitTo;
                    const dashboardItems: SearchResult = {
                        title: 'Next birthdays:',
                        items: [],
                        footer: {text: '', buttons: [
                            {link: '/birthdays', linkText: 'All birthdays', icon: 'far fa-calendar-alt'},
                            {link: '/birthdays/new', linkText: 'New birthday', icon: 'fas fa-plus-circle'}
                            ]},
                        icon: 'far fa-calendar-alt'
                    };

                    for (let a = 0; a < birthdays.length; a++) {
                        const birthday = new Date(birthdays[a].birthday);
                        const label = birthdays[a].firstname +
                            ' ' + birthdays[a].lastname +
                            ' - turns ' + birthdays[a].age +
                            ' in ' + birthdays[a].daysUntil + ' days' +
                            ', birthday is on: ' + birthday.toDateString();
                        const resultItem = {
                            label: label,
                            routerLink:  ['/birthdays/edit/', birthdays[a]._id],
                            link: ''
                        };
                        dashboardItems.items.push(resultItem);
                    }
                    this.dashboardService.addDashboardItem('birthdays', dashboardItems);
                }
            );
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/birthdays/birthdays.module.ts